export default __webpack_public_path__ + "static/media/home1.60a39e75.jpg";